export default function getImageDimensions(url: string): { width: number | "auto"; height: number | "auto" } {
  const match = url.match(/\/(\d+)x(\d+)\//);
  if (match) {
    const [, width, height] = match;
    return { width: Number(width), height: Number(height) };
  }
  return { width: "auto", height: "auto" };
}
